/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-12-06 09:53:45
 * @LastEditTime: 2020-03-12 10:56:44
 * @LastEditors: 李方强
 */
export function dispatch(context, componentName, eventName, params) {
  let parent = context.$parent || context.$root
  let name = parent.$options.componentName
  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent
    if (parent) {
      name = parent.$options.componentName
    }
  }
  if (parent) {
    parent.$emit(...[eventName].concat(params))
  }
}
// 过滤入参为空字符串
export function getFilterNull(form) {
  for (const i in form) {
    if (form[i] === '') {
      delete form[i]
    } else if (i === 'total') {
      delete form[i]
    }
  }
  return form
}

// 复制
export function handleCopy(id) {
  const target = document.createElement('div')
  target.id = 'tempTarget'
  target.style.opacity = '0'
  target.innerText = id
  const range = document.createRange()
  const target2 = document.body.appendChild(target)
  try {
    range.selectNode(target)
    window.getSelection().removeAllRanges()
    window.getSelection().addRange(range)
    document.execCommand('copy')
    window.getSelection().removeAllRanges()
    this.$message.success('复制成功')
  } catch (e) {
    this.$message.success('复制失败')
  }
  target.remove()
  target2.remove()
}

const hasTouch = 'ontouchstart' in window
const startEvent = hasTouch ? 'touchstart' : 'mousedown'
const moveEvent = hasTouch ? 'touchmove' : 'mousemove'
const endEvent = hasTouch ? 'touchend' : 'mouseup'
const cancelEvent = hasTouch ? 'touchcancel' : 'mouseup'

export const deviceEvent = {
  hasTouch,
  startEvent,
  moveEvent,
  endEvent,
  cancelEvent
}

export const getClient = (e) => {
  const clientX = hasTouch ? e.touches[0].clientX : e.clientX
  const clientY = hasTouch ? e.touches[0].clientY : e.clientY
  return {
    x: clientX,
    y: clientY
  }
}
